import { Grid, Typography } from "@mui/material";
import UserVersions from "./UserVersions";
import { useSingleUserControl } from "../../../context/SuperAdmin/SingleUserControlContext";
import { Spinner } from "../../Loading/Spinner";
import UserAccount from "./UserAccount";

const SingleUserPanel = () => {
  const { rdsUser, isLoadingOtherUser, isLoadingSus } = useSingleUserControl();
  return (
    <>
      {/* Título */}
      <Grid item>
        <Typography variant={"h4"} sx={{ color: "#005559", fontSize: "30px" }}>
          <b>Usuario</b> | {rdsUser?.email} ({rdsUser?.version})
        </Typography>
      </Grid>

      {isLoadingOtherUser ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Secciones de usuarios */}
          <Grid item>
            <UserVersions />
          </Grid>
        </>
      )}

      {isLoadingSus ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Secciones de cuenta */}
          <Grid item>
            <UserAccount />
          </Grid>
        </>
      )}
    </>
  );
};

export default SingleUserPanel;
